import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../../web/components-v2/Button';
import { styleSheet } from '../styles';

interface IProps {
	buttonLabel?: string;
	icon: React.ReactNode;
	isLoading?: boolean;
	onClick: () => void;
}

export const UtilityCard: React.FC<IProps> = ({ buttonLabel, icon, isLoading, onClick }) => {
	return (
		<div className={css(styleSheet.utilityCard)}>
			<div className={css(styleSheet.utilityCardIcon)}>{icon}</div>
			<div className={css(styleSheet.utilityActions)}>
				<Button variant='secondary' isLoading={isLoading} onClick={onClick}>
					{buttonLabel}
				</Button>
			</div>
		</div>
	);
};
